import { Link } from "react-router-dom";

const RodoPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="sticky top-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#0F2557] font-bold text-lg">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-base"></i>
            </div>
            Wróć na stronę główną
          </Link>
          <span className="text-xs text-gray-400">Ostatnia aktualizacja: 03.04.2026</span>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-14 lg:py-20">
        <header className="mb-12">
          <span className="inline-block text-[#0F2557] text-sm font-semibold tracking-wide uppercase mb-3">Dokument prawny</span>
          <h1 className="text-4xl font-bold text-[#1A1A2E] mb-4">Informacja o przetwarzaniu danych osobowych (RODO)</h1>
          <p className="text-gray-500 text-lg">Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO) informujemy o zasadach przetwarzania Twoich danych osobowych.</p>
        </header>

        <div className="bg-[#F7F8FA] rounded-xl p-6 mb-10 border-l-4 border-[#0F2557]">
          <p className="text-sm text-gray-600 leading-relaxed">
            <strong className="text-[#1A1A2E]">RODO</strong> (ang. GDPR — General Data Protection Regulation) to unijne rozporządzenie o ochronie danych osobowych, które obowiązuje od 25 maja 2018 r. Nakłada ono obowiązek informowania użytkowników o tym, jak ich dane są zbierane i przetwarzane.
          </p>
        </div>

        <div className="prose max-w-none text-gray-600 leading-relaxed space-y-10">

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">1. Kto jest administratorem Twoich danych?</h2>
            <p>Administratorem Twoich danych osobowych jest Tomasz Kowalski, prowadzący działalność w zakresie tworzenia stron internetowych dla firm usługowych.</p>
            <div className="mt-4 bg-[#F7F8FA] rounded-lg p-5 space-y-2">
              <p className="text-sm"><strong className="text-[#1A1A2E]">E-mail:</strong> <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] hover:underline">tomasz.kdp@gmail.com</a></p>
              <p className="text-sm"><strong className="text-[#1A1A2E]">Telefon:</strong> <a href="tel:+48509963499" className="text-[#0F2557] hover:underline">+48 509 963 499</a></p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">2. W jakim celu i na jakiej podstawie przetwarzamy dane?</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-[#0F2557] text-white">
                    <th className="text-left px-4 py-3 rounded-tl-lg">Cel przetwarzania</th>
                    <th className="text-left px-4 py-3">Podstawa prawna</th>
                    <th className="text-left px-4 py-3 rounded-tr-lg">Okres przechowywania</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100">
                    <td className="px-4 py-3 text-gray-700">Odpowiedź na zapytanie kontaktowe</td>
                    <td className="px-4 py-3 text-gray-500">Art. 6 ust. 1 lit. b RODO</td>
                    <td className="px-4 py-3 text-gray-500">12 miesięcy</td>
                  </tr>
                  <tr className="border-b border-gray-100 bg-[#F7F8FA]">
                    <td className="px-4 py-3 text-gray-700">Realizacja umowy o usługi</td>
                    <td className="px-4 py-3 text-gray-500">Art. 6 ust. 1 lit. b RODO</td>
                    <td className="px-4 py-3 text-gray-500">5 lat od zakończenia umowy</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="px-4 py-3 text-gray-700">Wystawianie faktur i rozliczenia</td>
                    <td className="px-4 py-3 text-gray-500">Art. 6 ust. 1 lit. c RODO</td>
                    <td className="px-4 py-3 text-gray-500">5 lat (obowiązek podatkowy)</td>
                  </tr>
                  <tr className="bg-[#F7F8FA]">
                    <td className="px-4 py-3 text-gray-700">Analityka i statystyki serwisu</td>
                    <td className="px-4 py-3 text-gray-500">Art. 6 ust. 1 lit. f RODO</td>
                    <td className="px-4 py-3 text-gray-500">Do czasu sprzeciwu</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">3. Twoje prawa wynikające z RODO</h2>
            <p className="mb-4">Na podstawie RODO przysługują Ci następujące prawa:</p>
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                { icon: "ri-eye-line", title: "Prawo dostępu (art. 15)", desc: "Możesz uzyskać potwierdzenie, czy przetwarzamy Twoje dane i dostęp do nich." },
                { icon: "ri-edit-line", title: "Prawo do sprostowania (art. 16)", desc: "Możesz żądać poprawienia nieprawidłowych lub uzupełnienia niekompletnych danych." },
                { icon: "ri-delete-bin-line", title: "Prawo do usunięcia (art. 17)", desc: "Możesz żądać usunięcia danych, gdy nie są już potrzebne do celów, dla których zostały zebrane." },
                { icon: "ri-pause-circle-line", title: "Prawo do ograniczenia (art. 18)", desc: "Możesz żądać ograniczenia przetwarzania w określonych przypadkach." },
                { icon: "ri-download-line", title: "Prawo do przenoszenia (art. 20)", desc: "Możesz otrzymać swoje dane w ustrukturyzowanym formacie i przenieść je do innego administratora." },
                { icon: "ri-forbid-line", title: "Prawo do sprzeciwu (art. 21)", desc: "Możesz wnieść sprzeciw wobec przetwarzania opartego na prawnie uzasadnionym interesie." },
              ].map((right) => (
                <div key={right.title} className="bg-[#F7F8FA] rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${right.icon} text-[#0F2557] text-base`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-[#1A1A2E]">{right.title}</h3>
                  </div>
                  <p className="text-xs text-gray-500 leading-relaxed">{right.desc}</p>
                </div>
              ))}
            </div>
            <p className="mt-4 text-sm">Aby skorzystać z powyższych praw, skontaktuj się: <a href="mailto:tomasz.kdp@gmail.com" className="text-[#0F2557] font-medium hover:underline">tomasz.kdp@gmail.com</a>. Odpowiemy w ciągu 30 dni.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">4. Prawo do skargi</h2>
            <p>Jeśli uważasz, że przetwarzanie Twoich danych narusza przepisy RODO, masz prawo wnieść skargę do organu nadzorczego — <strong className="text-[#1A1A2E]">Prezesa Urzędu Ochrony Danych Osobowych (UODO)</strong>.</p>
            <div className="mt-3 bg-[#F7F8FA] rounded-lg p-4">
              <p className="text-sm text-gray-600">Urząd Ochrony Danych Osobowych<br />ul. Stawki 2, 00-193 Warszawa<br /><a href="https://uodo.gov.pl" target="_blank" rel="nofollow noopener noreferrer" className="text-[#0F2557] hover:underline">www.uodo.gov.pl</a></p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">5. Przekazywanie danych poza EOG</h2>
            <p>Dane osobowe nie są przekazywane do państw trzecich (poza Europejski Obszar Gospodarczy). W przypadku korzystania z narzędzi analitycznych (np. Google Analytics), dane mogą być przetwarzane przez Google LLC na podstawie standardowych klauzul umownych zatwierdzonych przez Komisję Europejską.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#1A1A2E] mb-3">6. Zautomatyzowane podejmowanie decyzji</h2>
            <p>Nie stosujemy zautomatyzowanego podejmowania decyzji ani profilowania w rozumieniu art. 22 RODO.</p>
          </section>

        </div>
      </main>

      <footer className="border-t border-gray-100 py-8 mt-10">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">&copy; {new Date().getFullYear()} Strony www dla firm usługowych. Wszelkie prawa zastrzeżone.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/polityka-prywatnosci" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Polityka prywatności</Link>
            <Link to="/rodo" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">RODO</Link>
            <Link to="/regulamin" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Regulamin</Link>
            <Link to="/polityka-cookies" className="text-xs text-gray-400 hover:text-[#0F2557] transition-colors">Cookies</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RodoPage;
